import { User, Phone } from "lucide-react";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import {
  // getUsagePredictionColor,
  getremainDaysColor,
} from "../../helpers/getUsagePredictionColor";
import {
  getPredictedDate,
  getRemainingDays,
} from "../../helpers/getPredictionDate";

const PredictionCard = ({ item }) => {
  const {
    station_id,
    station_name,
    fieldTechnician: { fullName, mobileNumber },
    operationalCylinder,
    averageUsageDays,
    operationalFrom,
  } = item;
  const style = "text-base flex";

  const serialNumber = operationalCylinder?.serialNumber || "N/A";

  // Safely format date
  const formattedStartDate = operationalFrom
    ? formatDate(operationalFrom)
    : "N/A";

  // Calculate predicted date
  const predictedDate = getPredictedDate(operationalFrom, averageUsageDays);
  const formattedPredictedDate = predictedDate
    ? formatDate(predictedDate)
    : "N/A";
  // Calculate remaining days
  const remainingDays = getRemainingDays(predictedDate);

  // Prediction avearage usage color
  // const { txtClr, border } = getUsagePredictionColor(
  //   averageUsageDays,
  //   operationalCylinder,
  // );
  // Remainign days color
  const { remBorder, remTxtClr, bgClr, boxBorder } =
    getremainDaysColor(remainingDays);

  return (
    <div className="cy-card relative">
      <p className="font-figtreeBold 2xl:text-2xl text-lg break-words whitespace-normal">
        {station_name}
        <span className="2xl:text-base text-sm">{` (${station_id})`}</span>
      </p>
      <div className="text-gray-600 mb-3">
        <p className={`pt-1 ${style}`}>
          <User size={20} className="mr-2" />
          {fullName}
        </p>
        <p className={`${style}`}>
          <Phone size={18} className="mr-2" />
          {mobileNumber}
        </p>
        <p className="pt-5 text-gray-600">Cylinder: {serialNumber}</p>
        <p className="text-gray-600">Started: {formattedStartDate}</p>
      </div>
      {/* Prediction date */}

      <p
        className={`text-center bg-gray-100 border-1 rounded-md py-[7px] px-1 font-figtree border-gray-200`}
      >
        {operationalCylinder
          ? `PREDICTED DATE : ${formattedPredictedDate}`
          : `NO
        OPERATIONAL CYLINDER`}
      </p>

      {/* Remaining days */}
      <div
        className={`text-center absolute right-3 bottom-20 ${remTxtClr} ${remBorder} border-1 px-1 rounded-md`}
      >
        {remainingDays === null ? "N/A" : `${remainingDays}`}
        <p className="text-xs font-figtreeMedium text-black">{`Day${remainingDays > 0 ? "s" : ""} left`}</p>
      </div>
      {/* Average usage */}
      <div
        className={`absolute right-3 top-2 text-center border-1 rounded-lg p-1`}
      >
        {averageUsageDays === 0 || !operationalCylinder ? (
          <span className="text-sm">N/A</span>
        ) : (
          <>
            {averageUsageDays}
            <span className="text-xs">{` Day${averageUsageDays > 0 ? "s" : ""}`}</span>
          </>
        )}
        <p className="text-xs font-figtreeMedium text-black">Avg Usage</p>
      </div>
    </div>
  );
};

export default PredictionCard;
